import { useState, useEffect } from 'react';
import { getAllPaginatedData } from '../config/api/methodsByApi';
import { useCallback } from 'react';

const useSelectOptions = (url, dataKey, param, firstOption = null) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getAllPaginatedData(url, dataKey, setOptions, param).finally(() => setLoading(false));
    
  }, [url]);

  return {
    options: firstOption ? [{ id: firstOption.id, label: firstOption.label }, ...options] : options,
    loading,
  };

  return { options, loading };
};

export default useSelectOptions;
